import React, { useState, useEffect } from 'react'
import { Container, LefContent, RightContent } from './styles'
import { Button, CircularProgress } from '../../../../components'
import useHistory from '../../../../hooks/useHistory'

const PillarCard = ({ card }) => {
  const history = useHistory()
  const [data, setData] = useState([
    { x: 1, y: 0 },
    { x: 2, y: 100 - 0 }
  ])
  const [dataPercent, setDataPercent] = useState(0)

  useEffect(() => {
    if (card) {
      const newDate = [
        { x: 1, y: card.percent },
        { x: 2, y: 100 - card.percent }
      ]
      setDataPercent(card.percent)
      setData(newDate)
    }
  }, [card])

  return (
    <Container>
      <LefContent>
        <h2>{card.title}</h2>
        {card.name && (
          <p>
            Respondido por {card.name} em {card.data}
          </p>
        )}

        <Button
          type="button"
          variant="textLink"
          text="Responder questionário"
          textWeight="bold"
          onClick={() => history.push(card.questionnaireLink)}
        />
      </LefContent>
      <RightContent>
        <CircularProgress data={data} dataPercent={dataPercent} />
      </RightContent>
    </Container>
  )
}

export default PillarCard
